import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import {  getAttributeList } from '../../../store/INV/Attributes/AttributesSlice';
import { useTranslation } from 'react-i18next';

const useGetAttributeList = () => {
  const dispatch = useAppDispatch();

  const { i18n } = useTranslation();
  useEffect(() => {
    dispatch(getAttributeList());
  }, []);

  const { AttributesList, error, loading } = useAppSelector((s) => s.Attributes);

  const AttributesListOptions = AttributesList?.map((item) => ({
    value: item.id,
    label: `${i18n.language === 'en' ? item.name : item.name2}`,
  }));

  return { AttributesList, AttributesListOptions, loading, error };
};

export default useGetAttributeList;
